define(function(require) {
  // templates & views
  const tpl = require('civicsViews/new_attachments/templates/t_lov_attachments_box.hbs');
  const AttachmentGroupListView = require('civicsViews/new_attachments/v_cpv_attachment_group_list.js');

  const IpsModelCollection = require('civicsBase/ipsModelCollection');

  const attachment_utility = require('civicsUtils/attachment_utility')

  // utils
  const ViewManager = require('civicsUtils/view_manager');
  const ModalRegion = require('civicsUtils/modal_region.js');
  const AttachmentConverter = require('civicsUtils/attachment_converter');
  const AvailableFeatures = require('civicsUtils/available_features');

  const Radio = require('backbone.radio');
  const AttachmentChannel = Radio.channel('addAttachmentChannel');


  return Marionette.LayoutView.extend({
    template: tpl,
    regions: {
      constraintsRegion: '@ui.constraintsDiv',
      listRegion: '@ui.listDiv',
      modalRegion: {
        selector: 'body .rhythm-modals',
        regionClass: ModalRegion,
      },
    },
    ui: {
      constraintsDiv: '.constraints-region',
      listDiv: '.list-region',
      attachmentFiles: '.attachment-files',
      downloadModalLink: '.download-modal-link',
      noAttachments: '.no-attachments',
    },
    events: {
      'click @ui.downloadModalLink': 'downloadAllAttachments',
    },
    childEvents: {
      'singleDownload:clicked': function(childView, filePath) {
        this.downloadAttachment(filePath);
      },
    },
    onBeforeDestroy: function() {
      this.radioChannel.reset();
    },
    initialize: function(options) {
      // general config
      this.config = options.config;

      this.globalConfig = ViewManager.globalConfig();

      // the product family of the current instrument, used for the catalog
      this.productFamily = options.productFamily;


      this.catalog = this.getCatalog();

      // the constraints for this instrument type
      this.constraints = options.constraints;

      // the electronic plan types for this instrument. we need to filter out attachments of these document types
      this.electronicPlanTypes = options.electronicPlanTypes ? options.electronicPlanTypes : new IpsModelCollection();

      this.electronicPlanCustomerComments = options.electronicPlanCustomerComments;

      this.electronicPlanCustomerSubmittal = options.electronicPlanCustomerSubmittal;

      // the attachments for this instrument
      this.attachments = this.filterAttachments(options.attachments);

      // true if this view is shown in the Review step of Submit Record, otherwise false
      this.isReviewProcess = options.isReviewProcess;

      // true is this view is shown in the Attachment step of Submit Record, otherwise false
      this.isAddProcess = options.isAddProcess;

      this.globalCanAdd = options.globalCanAdd;

      // Parent moniker
      this.parentMoniker = options.parentMoniker;

      // Primary key of instrument
      this.parentPrimaryKey = options.parentPrimaryKey;

      // key to determine where to get localization items
      this.localizationKey = options.localizationKey ? options.localizationKey : 'COMMON_ATTACHMENTS';

      // list of the constraints that are still missing requirements, according to the status check
      this.usesStatusCheckRequirements = options.usesStatusCheckRequirements;
      this.statusCheckRequirements = options.statusCheckRequirements;

      this.viewName = options.viewName !=null ? options.viewName : Math.floor(Math.random()*100000);

      this.groupLabel = {
        'requiredFiles': i18n.t('CIVICS.'+ this.localizationKey + '.REQUIRED_FILES_LABEL'),
        'optionalFiles': i18n.t('CIVICS.'+ this.localizationKey + '.OPTIONAL_FILES_LABEL'),
        'optionalFilesOnly': i18n.t('CIVICS.'+ this.localizationKey + '.OPTIONAL_FILES_ONLY_LABEL'),

      }

      this.sortConstraints();

      this.enabledProviders = this.globalConfig.get('attachments').get('enabledProviders');
      this.isProviderEnabled = this.enabledProviders.includes(this.catalog);

      // Global on/off for showing the 'add' button - portlet config, instrument status, etc
      this.globalCanAdd = options.globalCanAdd && this.isProviderEnabled;

      this.rawAttachments = new IpsModelCollection();
      if (this.isAddProcess) {
        this.rawAttachments = options.rawAttachments;
      }

      this.isMobile = function() {
        var check = false;
        (function(a) {
          if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
        })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
      }();

      this.radioChannel = AttachmentChannel;
      this.radioChannel.on('attachments:added', function(myList) {
        // Pass the list back up to the parent (ie: HearingDetails)
        this.triggerMethod('attachments:added', myList);
        // refresh the list with the new attachments
      }.bind(this));

      this.radioChannel.on('attachments:done', function(myList) {
        // Pass the list back up to the parent (ie: HearingDetails)
        this.triggerMethod('attachments:done', myList);
      }.bind(this));

      this.radioChannel.on('attachments:validate', function(view) {
        this.triggerMethod('attachments:validate', view);
      }.bind(this));

      this.radioChannel.on('attachments:delete', function(view) {
        this.triggerMethod('attachments:delete', view);
      }.bind(this));

      this.radioChannel.on('singleDownload:clicked', function(filepath) {
        this.downloadAttachment(filepath);
      }.bind(this));


      this.radioChannel.on('attachments:edit', function(v) {
        var modelToUpdate = null;
        this.triggerMethod('attachments:edit', v);
        if (this.isAddProcess)
          modelToUpdate = this.attachments.find(function(m) {
            return m.get('cid') == v.cid
          });
        else
          modelToUpdate = this.attachments.find(function(m) {
            if(m.get('id')){
              return m.get('id') == v.id
            }
          });

        if (modelToUpdate != null) {
          modelToUpdate.set(v.toJSON());
        }
        //	this.render();
      }.bind(this));
      //only show the alert on page load.
      this.showVirusAlert();
      
      // Setup monitoring after all properties are initialized
      this.setupMonitoringOfAttachments();
    },
    setupMonitoringOfAttachments: function() {
      // Pass productFamily directly - utility will convert to moniker
      attachment_utility.monitorScanStatus(
        this.attachments,
        this.parentMoniker, 
        this.options.parentPrimaryKey
      ).then((result) => {
        if (result.noPendingFiles) return;
        const rawAttachments = new IpsModelCollection(result.attachments);
        const filteredAttachments = this.filterAttachments(rawAttachments);
        this.attachments.reset(filteredAttachments.models);
        this.render();
        this.showListViews();
        this.showVirusAlert();
      }).catch((error) => {
        //leave this console log in - this will only happen when we have a real error that we need to be able to track.
        console.log('Error monitoring attachment scans: ' + error.message);
      });
    },
    getCatalog: function() {
      var catalog;

      var globalConfig = this.globalConfig;

      switch (this.productFamily.toUpperCase()) {
        case "SERVICEREQUEST":
          catalog = globalConfig.get("attachments").get("crmCatalog");
          break;
        case "BUILDING":
          catalog = globalConfig.get("attachments").get("buildingCatalog");
          break;
        case "BUSINESSLICENSE":
          catalog = globalConfig.get("attachments").get("licenseCatalog");
          break;
        case "CODEENFORCEMENT":
          catalog = globalConfig.get("attachments").get("caseCatalog");
          break;
        case "PLANNING":
          catalog = globalConfig.get("attachments").get("planningCatalog");
          break;
        case "PROJECT":
          catalog = globalConfig.get("attachments").get("projectCatalog");
          break;
        case "TRADELICENSE":
          catalog = globalConfig.get("attachments").get("tradeCatalog");
          break;
        case "USE":
          catalog = globalConfig.get("attachments").get("useCatalog");
          break;
        default:
          catalog = globalConfig.get("attachments").get("defaultCatalog");
      }

      // If the product specific catalog is not set, use the default
      if (!catalog || catalog.length == 0) {
        catalog = globalConfig.get("attachments").get("defaultCatalog");
      }
      return catalog;
    },
    getConstraint: function(attachment) {
      let constraint = null;
      this.constraints.each(function(aConstraint) {
        if (aConstraint.get('name') == attachment.get('documentType').get('name')) {
          constraint = aConstraint;
        }
      });

      return constraint;
    },
    filterAttachments: function(attachments) {
      var self = this;
      var constraintNames = [];
      var electronicPlanNames = [];

      self.electronicPlanTypes.each(function(type) {
          electronicPlanNames.push(type.get('name'));

      });
      self.constraints.each(function(constraint) {
        if(AvailableFeatures.ElectronicPlanForCustomersConfig()) {
          // if comments is off but submittal is on, these types were not automatically filtered out
            if(!constraint.get('isElectronicPlanType')) {
              constraintNames.push(constraint.get('name'));
            }
        } else {
          constraintNames.push(constraint.get('name'));
        }
      });

      var convertedAttachments = attachments ? new IpsModelCollection(AttachmentConverter.convertAttachments(attachments.toJSON())) : new IpsModelCollection();
      var filteredAttachments = new IpsModelCollection();

      var filterOutAttachments = true;

      //Filter attachments list to only display non-electronic plan attachments and document types are included in the attachment constraints response

      if(AvailableFeatures.ElectronicPlanForCustomersConfig()) {
        if(this.electronicPlanCustomerComments && this.electronicPlanCustomerSubmittal) {
          // if both are on, the attachments should be in the EPlan box
          filterOutAttachments = true;
        } else if (this.electronicPlanCustomerComments && !this.electronicPlanCustomerSubmittal){
          // if comments are on but submittal is not, the attachments should be in the EPlan box
          filterOutAttachments = true;
        } else if (!this.electronicPlanCustomerComments && this.electronicPlanCustomerSubmittal) {
          // if comments are off but submittal is on, the attachments should be in the EPlan box
          filterOutAttachments = true;
        } else if (!this.electronicPlanCustomerComments && !this.electronicPlanCustomerSubmittal) {
          // if comments are off and submittal is off, the attachments should be in the attachments box
          filterOutAttachments = false;
        }
      } else {
        filterOutAttachments = true;
      }


        convertedAttachments.each(function(attachment) {
          if(constraintNames.includes(attachment.get('documentType').get('name')) || !electronicPlanNames.includes(attachment.get('documentType').get('name'))) {
            filteredAttachments.add(attachment);
          }
        });


      return filteredAttachments;
    },
    downloadAttachment: function(filepath) {
      var src = filepath.replace(/ /g, '_');
      if (this.isMobile) {
        window.open(src, "_blank");
      } else {
        var iframe = window.document.createElement('iframe');
        var $iframe = $(iframe).attr({
          style: 'display:none',
          src: src,
        });
        this.ui.attachmentFiles.append($iframe);
      }
    },
    downloadAllAttachments: function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      var index = 0;
      var self = this;
      this.attachments.each(function(attachment) {
        var virusScanResults = attachment.get('virusScanResults')?.toJSON() || {safe: true};
        if (virusScanResults.safe !== true) {
          return;
        }
        
        var constraint = self.getConstraint(attachment);
        if ((constraint.get('permissions') && constraint.get('permissions').get('open'))) {
          window.setTimeout(function() {
            self.downloadAttachment(attachment.get('documentUri'));
          }, index * 1000);
          index++;
        }
      });

      //stop event propagation
      return false;
    },
    getRequiredConstraints: function() {
      var self = this;
      var requiredConstraints = new Backbone.Collection();
      self.constraints.each(function(constraint) {
        if (constraint.get('minimumAttachmentsRequired') > 0) {
          requiredConstraints.add(constraint);
        }
      });
      return requiredConstraints;
    },
    countMissingRequirements: function() {
      var missingReq = 0;
      var self = this;
      self.attachments.each(function(attach) {
        if (attach.missingRequirements && attach.missingRequirements.length > 0) {
          missingReq++;
        } else if (attach.get('missingRequirements') && attach.get('missingRequirements').length > 0) {
          missingReq++;
        }
      });
      return missingReq;
    },
    countIncompleteConstraints: function() {
      var self = this;
      var ret = 0;

      if (self.constraintsView) {
        self.constraintsView.children.each(function(view) {
          if (!view.isComplete()) {
            ret++;
          }
        });
      }

      return ret;
    },
    checkTotalSizeConstraint: function() {
      var ret = true;
      var totalSize = 0;

      this.attachments.each(function(model) {
        totalSize += model.get("file").get("size");
        if( totalSize > 262144000 ) {      //Total combined files size must be less than 250MB
          ViewManager.openAlert(i18n.t('CIVICS.ATTACHMENTS.ERROR_TOTAL_SIZE_ERROR'));
          ret = false;
          exit;
        }
      });
      return ret;
    },
    onRender: function() {
      this.$el.rhythmCivicsTooltipInit();
      this.$el.rhythmThemeInitCivics();
      this.$el.rhythmThemeInit();
      
    },
    showVirusAlert:function(){
			if(this.hasInfectedFile()){
				ViewManager.openAlert(i18n.t('CIVICS.ATTACHMENTS.VIRUS_SCAN_STATUS.VIRUS_DETECTED_ALERT'));
			}
		},
    hasInfectedFile: function(){
			return  this.attachments.models.some(model => {
				let virusScanResults = model.get('virusScanResults')?.toJSON() || {infected:false};
				return virusScanResults.infected === true;
			});
		},
    sortConstraints: function() {
      var self = this;
      self.requiredConstraints = new Backbone.Collection();
      self.optionalConstraints = new Backbone.Collection();
      self.constraints.each(function(c) {
        if (c.get('minimumAttachmentsRequired') > 0) {
          self.requiredConstraints.add(c);
        } else {
          self.optionalConstraints.add(c);
        }
      });

    },
    hasAddPermissionOnOptionalConstraints: function() {
      var self = this;
      var ret = false;
      self.optionalConstraints.each(function(constraint) {
        var permissions = constraint.get('permissions');
        if(permissions && permissions.get('add')) {
          ret = true;
        }
      });

      return ret;
    },
    hasOptionalAttachments: function() {
      var self = this;
      var ret = false;
      var docTypeNames = [];
      self.optionalConstraints.each(function(constraint) {
        var permissions = constraint.get('permissions');
        if(permissions && permissions.get('list')) {
          docTypeNames.push(constraint.get('name'));
        }
      });

      self.attachments.each(function(attach) {
        var doctype = attach.get('documentType');
        if(doctype != null) {
          if(docTypeNames.includes(doctype.get('name'))) {
            ret = true;
          }
        }
      });

      return ret;

    },
    showOptionalSection: function() {
      return this.hasAddPermissionOnOptionalConstraints() || this.hasOptionalAttachments();
    },
    // hasNonConstraintAttachments: function() {
    //   var ret = false;

    //   this.attachments.each(function(attach) {
    //     if(attach.get('nonConstraintAttachment')) {
    //       ret = true;
    //     }
    //   });

    //   return ret;
    // },
    onShow: function() {
      this.showListViews();
    },
    getCommonViewOptions: function() {
      return {
        config: this.config,
        catalog: this.catalog,
        productFamily: this.productFamily,
        modalRegion: this.modalRegion,
        isReviewProcess: this.isReviewProcess,
        isAddProcess: this.isAddProcess,
        globalCanAdd: this.globalCanAdd,
        attachments: this.attachments,
        rawAttachments: this.rawAttachments,
        parentMoniker: this.parentMoniker,
        parentPrimaryKey: this.parentPrimaryKey
      };
    },
    showListViews: function() {
      const commonOptions = this.getCommonViewOptions();

      if(this.constraintsView){
        this.constraintsView.destroy();
        this.constraintsRegion.empty();
      }

      if(this.listView){
        this.listView.destroy();
        this.listRegion.empty();
      }
      
      if (this.requiredConstraints.length > 0) {
        this.ui.noAttachments.hide();
        
        this.constraintsView = new AttachmentGroupListView({
          ...commonOptions,
          groupLabel: this.groupLabel.requiredFiles,
          constraints: this.requiredConstraints,
          isOptionalFileView: false,
          usesStatusCheckRequirements: this.usesStatusCheckRequirements,
          statusCheckRequirements: this.statusCheckRequirements,
          viewName: this.viewName
        });
        
        this.constraintsRegion.show(this.constraintsView);
      }
      
      if (this.optionalConstraints.length > 0 && this.showOptionalSection()) {
        this.ui.noAttachments.hide();
        
        this.listView = new AttachmentGroupListView({
          ...commonOptions,
          groupLabel: this.requiredConstraints.length > 0 ? this.groupLabel.optionalFiles : this.groupLabel.optionalFilesOnly,
          constraints: this.optionalConstraints,
          requiredConstraints: this.requiredConstraints,
          isOptionalFileView: true
        });
        
        this.listRegion.show(this.listView);
      }
    },
    hasOpenPrivileges: function() {
      var self = this;
      var canOpen = false;
      var hasAttachmentsForConstraint = false;
      self.constraints.each(function(constraint) {
        if (constraint.get('permissions').get('open')) {
          self.attachments.each(function(attach) {
            if (attach.get('documentType') && attach.get('documentType').get('name') == constraint.get('name')) {
              hasAttachmentsForConstraint = true;
            }
          });
          canOpen = true;
        }
      });

      return canOpen && hasAttachmentsForConstraint;
    },
    // Counts how many files are safe to download (not infected, not pending scan, and user has permission)
    countDownloadableFiles: function() {
      var self = this;
      var count = 0;
      
      this.attachments.each(function(attachment) {
        // Check if file is safe (not infected and not pending scan)
        let virusScanResults = attachment.get('virusScanResults')?.toJSON() || {safe: true};
        if (virusScanResults.safe !== true) {
          return; // Skip infected or pending files
        }
        
        // Check if user has permission to download this file
        var constraint = self.getConstraint(attachment);
        if (constraint && constraint.get('permissions') && constraint.get('permissions').get('open')) {
          count++;
        }
      });
      
      return count;
    },
    templateHelpers: function() {

      var numMissingRequirements = this.countMissingRequirements();
      // Only show download all button if there are 2+ files that can actually be downloaded
      var downloadableCount = this.countDownloadableFiles();
			return {
				virusDetected:this.hasInfectedFile(),
        count: this.attachments.length,
        ShowDownloadAll: downloadableCount >= 2 && !this.isAddProcess,
        noConstraints: this.requiredConstraints.length == 0,
        noOptional: this.optionalConstraints.length == 0 || !this.showOptionalSection(),
        hasMissingRequirements: numMissingRequirements > 0 ? true : false,
        numMissingRequirements: numMissingRequirements,
        missingRequirementsAlertText: (numMissingRequirements > 1) ? numMissingRequirements + i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIREMENTS') : numMissingRequirements + i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIREMENT'),
        disableUpload: !this.isProviderEnabled,
        viewName: this.viewName,
      };
    },

  });
});
